<template>
	<div>

		<div v-for="item,index in 10" style="display: flex;margin-bottom: 0.2rem;justify-content: space-between;">
			<div style="display: flex;">
				<div style="width: 0.5rem;height: 0.5rem;background: #ccc;border-radius: 50%;margin-right: 0.12rem;">

				</div>
				<div
					style="height: 0.5rem;display: flex;flex-direction: column;justify-content: space-between;width: 1.52rem">
					<div style="font-size: 0.16rem;color: #333333;">吴宇森</div>
					<div style="color: #015243;background:#E1FEFC ;padding: 0.02rem 0.12rem;box-sizing: border-box;
				font-size: 0.12rem;">标识山西认证导演</div>
				</div>
			</div>

			<div
				style="margin-left: 0.25rem;height: 0.5rem;display: flex;flex-direction: column;justify-content: space-between;">
				<div style="font-size: 0.12rem;">
					<span>创作</span>
					<span style="color: #000000;">&nbsp;74&nbsp;</span>
					<span>&nbsp;|&nbsp;</span>
					<span>粉丝</span>
					<span style="color: #000000;">&nbsp;74&nbsp;</span>
					<span>&nbsp;|&nbsp;</span>
					<span>签单</span>
					<span style="color: #000000;">&nbsp;74&nbsp;</span>
				</div>
				<div style="font-size: 0.12rem;">主视觉项目合作，特效、视频合成等</div>
			</div>
			<div class="bnt">
				进入主页
			</div>
		</div>
		<div style="display: flex;justify-content: center;margin-top: 0.01rem;">
			<el-pagination background layout="prev, pager, next" :total="1000" />
		</div>

	</div>
</template>

<script>
</script>

<style scoped>
	.bnt {
		width: 0.8rem;
		height: 0.3rem;
		background: #C01A26;
		border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
		opacity: 1;
		text-align: center;
		line-height: 0.3rem;
		color: #fff;
		margin: 0.08rem 0;
	}
</style>